export const removeElementFromArray = (arr: string[], el: string) => arr.filter((element) => element !== el)
